import axios from 'axios'
import * as store_token from '@/services/store_token.js'
import Vue from 'vue'
import { login } from "@/services/api";

const server_path = 'http://' + process.env.HOST + ':8000/';

const state = () => ({
  status: '',
  auth_token: store_token.getlocalToken('auth_token') || '',
  user : store_token.getlocalToken('user') || '',
  rol : store_token.getlocalToken('rol') || '',
})

const mutations = {
  auth_request(state){
    state.status = 'loading'
  },
  auth_success(state, data){
    state.status = 'success'
    state.auth_token = data.auth_token
    state.user = data.user
    state.rol = data.rol
  },
  auth_error(state){
    state.status = 'error'
  },
  logout(state){
    state.status = ''
    state.auth_token = ''
    state.rol = ''
  },
  auth_validate(state, auth_token){
    state.status = 'success'
    state.auth_token = auth_token
  }
}

const actions = {
  login({commit}, user){
      return new Promise((resolve, reject) => {
        commit('auth_request')
        axios({url: server_path + 'login/', data: user, method: 'POST' })
        .then(resp => {
            const data = {
              auth_token : resp.data.access,
              user : user.username,
              rol : user.rol
            }
            store_token.setlocalToken('auth_token',data.auth_token)
            store_token.setlocal('user',data.user)
            store_token.setlocal('rol',data.rol)
            commit('auth_success',data)
            Vue.noty.success('Welcome '+ data.user);
            resolve(resp)
        })
        .catch(err => {
          commit('auth_error')
          //Vue.noty.error('Incorrect password or user')
          store_token.deletelocalToken('auth_token')
          reject(err)
        })
      })
  },
  async authenticate({ commit }, user) {
    try {
      const {success} = await login(user)
      //console.log(user)
      if(success == true){
        const data = {
          auth_token : 'Token',
          user : user.username,
          rol : 'Admin'
        }
        store_token.setlocalToken('auth_token',data.auth_token)
        store_token.setlocal('user',data.user)
        store_token.setlocal('rol',data.rol)
        commit('auth_success',data)
      } else{
        commit('auth_error')
      }
      commit('auth_success',data)
    } catch (e) {
      commit('auth_error')
    }
  },
  logout({commit}){
    return new Promise((resolve, reject) => {
      commit('logout')
      store_token.deletelocalToken('auth_token')
      Vue.noty.success("Goodbye")
      Vue.router.push('/')
      resolve('OK')
    })
  }
}

 const getters = {
    isLoggedIn(state, getters){
      return !!state.auth_token
    },
    authStatus(state, getters){
      return state.authStatus
    },
    token(state, getters){
      return state.token
    },
    user(state, getters){
      return state.user
    },
    rol(state, getters){
      return state.rol
    },
  }

  export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
  }